export enum ClienteEnums {
    ABERTO = "22f3645d-4bdf-443f-8edf-9e75bed6e319",
    ENCERRADO = "541ed947-12c9-401a-9902-dbd7b8884a9c",
}